import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Seller from '../../../core/models/Seller';
import tableColumnTextFilterConfig from '../../../utils/searchUtil';

interface IProps {
  isLoading: boolean;
  sellers: Seller[] | undefined;
}

const columns: ColumnsType<Seller> = [
  {
    title: 'Name',
    dataIndex: 'personInCharge',
    key: 'personInCharge',
    sorter: (a, b) => a.personInCharge.localeCompare(b.personInCharge),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Seller>(),
    onFilter: (value, record) => {
      return record.personInCharge
        .toString()
        .toLowerCase()
        .includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Seller>(),
    onFilter: (value, record) => {
      return record.email.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Company Name',
    dataIndex: 'companyName',
    key: 'companyName',
    sorter: (a, b) => a.companyName.localeCompare(b.companyName),
    render: (text: string) => text,
    ...tableColumnTextFilterConfig<Seller>(),
    onFilter: (value, record) => {
      return record.companyName.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
  {
    title: 'Monthly Selling Volume',
    dataIndex: ['volumeOfPotential', 'volume'],
    key: 'volumeOfPotential',
    sorter: (a, b) => a.volumeOfPotential.id - b.volumeOfPotential.id,
  },
  {
    title: 'Phone Number',
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
  },
  {
    title: 'City',
    dataIndex: 'city',
    key: 'city',
    sorter: (a, b) => a.city.localeCompare(b.city),
  },
  {
    title: 'Status',
    dataIndex: ['status', 'name'],
    key: 'status',
    sorter: (a, b) => a.status.id - b.status.id,
    filters: [
      {
        text: 'Approved',
        value: '2',
      },
      {
        text: 'Rejected',
        value: '3',
      },
    ],
    onFilter: (value, record) => {
      return record.status.id.toString().toLowerCase().includes(value.toString().toLowerCase());
    },
  },
];

const SellerTable: React.FC<IProps> = ({ isLoading, sellers }) => {
  const navigate = useNavigate();

  return (
    <Table
      dataSource={sellers}
      columns={columns}
      rowKey='id'
      loading={isLoading}
      size='small'
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            navigate(`/users/sellers/${record.id}`);
          },
        };
      }}
    />
  );
};

export default SellerTable;
